import React from 'react'

import PageLink from '@/link.js'
import { 
  Logo,
  Twitter,
  Instagram,
  Facebook
} from '@/svgs.js'

const Footer = () => (
  <footer className='bcp p15 footer'>
    <div className='container--xl ma f fw jcb ais'>
      <div className='footer__logo x'>
        <PageLink to='/'>
          <Logo />
        </PageLink>
      </div>
      <div className='f jcb ais x cb footer__links py1'>
        <div>
          <PageLink to='/whats-in-store' className='block pb05'>What's in store</PageLink>
          <PageLink to='/about' className='block pb05'>About</PageLink>
          <PageLink to='/locations' className='block pb05'>Locations</PageLink>
          <PageLink to='/events' className='block pb05'>Events</PageLink>
          <PageLink to='/membership' className='block'>Brand Partnerships</PageLink>
        </div>
        <div>
          <div className='y f jcb footer__address ais'>
            <p className='mt0 pt0 mb1'>120 Maiden Ln<br />San Francisco, CA<br />94108</p>
            <div className='footer__social f aic jcs'>
              <a href='https://www.facebook.com/visitrestore/' target='_blank' className='mr1' rel='noopener noreferrer'>
                <Facebook />
              </a>
              <a href='https://twitter.com/visitrestore' target='_blank' className='mr1' rel='noopener noreferrer'>
                <Twitter />
              </a>
              <a href='https://www.instagram.com/visitrestore/' target='_blank' className='mr1' rel='noopener noreferrer'>
                <Instagram />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className='x caps'>
        <PageLink to='/' className='mr1 x-small'>Restore &copy;</PageLink>
        <PageLink to='/privacy-policy' className='mr1 x-small'>Privacy Policy</PageLink>
        <PageLink to='/terms-of-service' className='mr1 x-small'>Terms of Service</PageLink>
      </div>
    </div>
  </footer>
)

export default Footer